/* ==========================================================================
   multipack-cart.js — Consolidation panier des packs « Nombre de pots »
   --------------------------------------------------------------------------
   Les compléments se vendent en VARIANTES multipack (option « Nombre de pots »
   1..6), prix dégressif baké dans la variante. Problème : si le client ajoute
   2 pots puis encore 2, Shopify fusionne en « 2 pots × 2 » (au tarif du 2-pack)
   au lieu de « 4 pots » (tarif du 4-pack). Ce script CONSOLIDE : pour chaque
   produit multipack ET chaque plan (achat unique / chaque abonnement), il somme
   le nombre total de pots et réécrit le panier vers la meilleure combinaison de
   variantes — décomposition gloutonne : autant de 6-packs que possible + le
   reste (ex. 8 = 6 + 2, « au prix du 6 »).

   Déclenchement : tout clic sur un <xo-cart-add> (buy box, sticky cart…), + au
   chargement (auto-réparation d'un panier déjà non optimal). Idempotent : sur un
   panier déjà optimal, ne fait rien. Le drawer est rafraîchi en place via la
   Section Rendering API (même mécanisme que jp-cart.js).
   ========================================================================== */
(function () {
  'use strict';
  if (window.__mpc) return;
  window.__mpc = true;

  var OPTION = 'Nombre de pots';
  var MAX = 6;                       // plus grand pack disponible
  var maps = {};                     // handle -> { nbPots: variantId }
  var busy = false, pending = false;
  var _f = window.fetch.bind(window); // fetch original (nos appels ne se ré-déclenchent pas)

  function potCount(item) {
    var ov = (item.options_with_values || []).filter(function (o) { return o.name === OPTION; })[0];
    return ov ? (parseInt(ov.value, 10) || 0) : 0;
  }
  function getCart() {
    return _f('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }
  function getMap(handle) {
    if (maps[handle]) return Promise.resolve(maps[handle]);
    return _f('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (p) {
        var idx = -1;
        (p.options || []).forEach(function (o, i) { if ((o.name || o) === OPTION) idx = i; });
        var m = {};
        if (idx > -1) p.variants.forEach(function (v) { var val = parseInt(v.options[idx], 10); if (val) m[val] = v.id; });
        maps[handle] = m;
        return m;
      });
  }
  /* Décompose N pots en la meilleure combinaison : k 6-packs + le reste. */
  function decompose(total, m) {
    var res = [], rem = total;
    var sixes = Math.floor(rem / MAX);
    if (sixes > 0 && m[MAX]) { res.push({ id: m[MAX], qty: sixes }); rem -= sixes * MAX; }
    if (rem > 0 && m[rem]) { res.push({ id: m[rem], qty: 1 }); rem = 0; }
    while (rem > 0 && m[1]) { res.push({ id: m[1], qty: 1 }); rem--; } // filet de sécurité
    return res;
  }
  function post(url, body) {
    return _f(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });
  }

  /* Réécrit le panier ; renvoie true si quelque chose a changé. */
  function consolidate() {
    return getCart().then(function (cart) {
      var groups = {};
      (cart.items || []).forEach(function (it) {
        var pc = potCount(it);
        if (!pc) return;
        var plan = (it.selling_plan_allocation && it.selling_plan_allocation.selling_plan && it.selling_plan_allocation.selling_plan.id) || '';
        var key = (it.handle || '') + '|' + plan;
        groups[key] = groups[key] || { handle: it.handle, plan: plan, total: 0, lines: [] };
        groups[key].total += pc * it.quantity;
        groups[key].lines.push(it);
      });
      var keys = Object.keys(groups);
      if (!keys.length) return false;
      var changed = false, chain = Promise.resolve();
      keys.forEach(function (k) {
        var g = groups[k];
        chain = chain.then(function () {
          return getMap(g.handle).then(function (m) {
            if (!Object.keys(m).length) return;
            var desired = decompose(g.total, m);
            var cur = {}; g.lines.forEach(function (l) { cur[l.variant_id] = (cur[l.variant_id] || 0) + l.quantity; });
            var des = {}; desired.forEach(function (x) { des[x.id] = (des[x.id] || 0) + x.qty; });
            var same = Object.keys(des).length === Object.keys(cur).length
              && Object.keys(des).every(function (id) { return cur[id] === des[id]; });
            if (same) return; // déjà optimal
            changed = true;
            var updates = {}; g.lines.forEach(function (l) { updates[l.key] = 0; });
            return post('/cart/update.js', { updates: updates }).then(function () {
              var c2 = Promise.resolve();
              desired.forEach(function (x) {
                c2 = c2.then(function () {
                  var b = { id: x.id, quantity: x.qty };
                  if (g.plan) b.selling_plan = g.plan;
                  return post('/cart/add.js', b);
                });
              });
              return c2;
            });
          });
        });
      });
      return chain.then(function () { return changed; });
    }).catch(function () { return false; });
  }

  /* Rafraîchit le contenu du cart drawer en place (Section Rendering API). */
  function refresh() {
    var content = document.querySelector('[xo-unique-id="xo-cart-mini-content"]');
    var sec = content;
    while (sec && !(sec.classList && sec.classList.contains('shopify-section'))) sec = sec.parentElement;
    if (!content || !sec) return Promise.resolve();
    var id = sec.id.replace(/^shopify-section-/, '');
    return _f('/?sections=' + encodeURIComponent(id), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (s) {
        var html = s[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');
        doc.querySelectorAll('[xo-unique-id]').forEach(function (fr) {
          var uid = fr.getAttribute('xo-unique-id');
          var c = document.querySelector('[xo-unique-id="' + uid + '"]');
          if (c) c.innerHTML = fr.innerHTML;
        });
      }).catch(function () {});
  }

  function run() {
    if (busy) { pending = true; return; }
    busy = true;
    consolidate().then(function (ch) {
      busy = false;
      if (ch) refresh();
      if (pending) { pending = false; setTimeout(run, 50); }
    });
  }

  /* Déclencheur : tout ajout au panier (buy box, sticky cart…). Deux passes
     pour couvrir la latence variable de l'ajout natif. */
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('xo-cart-add')) {
      setTimeout(run, 700);
      setTimeout(run, 1800);
    }
  }, true);

  /* Auto-réparation au chargement (panier laissé non optimal). */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { setTimeout(run, 400); });
  } else {
    setTimeout(run, 400);
  }
})();
